






import Vue from 'vue';

export default Vue.component('button-toggle', {
  name: 'ButtonToggle',
  model: {
    prop: 'modelValue',
    event: 'change'
  },
  props: {
    modelValue: {
      type: Boolean,
      default: false
    },
    trueValueWord: {
      type: String,
      default: "AND"
    },
    falseValueWord: {
      type: String,
      default: "OR"
    },
    disabled: {
      default: false
    }
  },
  computed: {
    buttonWord (): any {
      return this.modelValue ? this.trueValueWord : this.falseValueWord;
    }
  },
  methods: {
    updateInput(event: any) {
      if (this.disabled) {
        return;
      }
      this.$emit('change', !this.modelValue )
    }
  }
})



// WEBPACK FOOTER //
// ./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/componentsReusable/ButtonToggleControl.vue